// removed by extract-text-webpack-plugin
module.exports = {"access-app-title":"app-pages-Employees-Role-RoleDetail-RoleForm-AccessApp-__AccessApp___1m6kp","access-app-description":"app-pages-Employees-Role-RoleDetail-RoleForm-AccessApp-__AccessApp___3CzJl","partial-checked":"app-pages-Employees-Role-RoleDetail-RoleForm-AccessApp-__AccessApp___YaaCT"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Role/RoleDetail/RoleForm/AccessApp/AccessApp.css
// module id = 2327
// module chunks = 0